import React from 'react';
import { DetectorType } from './detectorForm';
import { CreateGroundingDetectorDialog } from '../Grounding/CreateGroundingDetector';
import { CreateAreaDetectorDialog } from '../Area/CreateAreaDetector';
import { CreateCableDetectorDialog } from '../Cable/CreateCableDetector';
import { CreateLineDetectorDialog } from '../Line/CreateLineDetector';

interface CreateDetectorDialogProps {
  detectorType: DetectorType;
  showDialog: boolean;
  setShowDialog: (showDialog: boolean) => void;
}

export const CreateDetectorDialog = ({
  detectorType,
  showDialog,
  setShowDialog,
}: CreateDetectorDialogProps) => {
  switch (detectorType) {
    case 'grounding':
      return (
        <CreateGroundingDetectorDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    case 'area':
      return (
        <CreateAreaDetectorDialog
          detectorType={detectorType}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    case 'cable':
      return (
        <CreateCableDetectorDialog
          detectorType={detectorType}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    case 'line':
      return (
        <CreateLineDetectorDialog
          detectorType={detectorType}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    default:
      return null;
  }
};
